import FirebaseConfig from "../firebaseConfig";

const db = FirebaseConfig.firestore(),
  case_managementRef = db.collection("casemanagement");

// add value in case management collection
export async function addCaseLog(data) {
  return new Promise(async (resolve, reject) => {
    try {
      let document = case_managementRef.doc();
      await document.set({
        id: document.id,
        mentee_id: data.mentee_id,
        mentor_name: data.mentor_name,
        mentee_name: data.mentee_name,
        meeting_mode: data.meeting_mode,
        contact_date: data.contact_date,
        meeting_duration: data.meeting_duration,
        gender: data.gender,
        ethnicity: data.ethnicity,
        referral_type: data.referral_type,
        employment_type: data.employment_type,
        mentee_goal: data.mentee_goal,
        risk_status: data.risk_status,
        housing_status: data.housing_status,
        session_activity: data.session_activity,
        progress: data.progress,
        steps: data.steps,
        success: data.success,
        comments: data.comments,
        concern: data.concern,
        created_by: localStorage.getItem("token"),
        created_at: FirebaseConfig.firestore.FieldValue.serverTimestamp(),
      });
      resolve(true);
    } catch (error) {
      reject(error);
    }
  });
}

// list mentee details
export async function getCaseManagement(callback) {
  let caselog = [];
  case_managementRef.get().then((querySnapshot) => {
    querySnapshot.forEach((doc) => {
      const {
        id,
        mentee_name,
        mentor_name,
        contact_date,
        meeting_duration,
        gender,
        ethnicity,
        referral_type,
        employment_type,
        mentee_goal,
        risk_status,
        housing_status,
        session_activity,
        progress,
        steps,
        success,
        comments,
        concern,
        created_at,
        created_by,
      } = doc.data();

      caselog.push({
        key: doc.id,
        id,
        mentor_name,
        mentee_name,
        contact_date,
        meeting_duration,
        gender,
        ethnicity,
        referral_type,
        employment_type,
        mentee_goal,
        risk_status,
        housing_status,
        session_activity,
        progress,
        steps,
        success,
        comments,
        concern,
        created_by,
        created_at,
      });
    });
    callback(caselog);
  });
}

export async function getCaseDetails(data, callback) {
  let casedoc = case_managementRef.doc(data);
  casedoc
    .get()
    .then((doc) => {
      if (doc.exists) {
        callback(doc.data(), true);
      }
    })
    .catch((error) => {
      callback({}, false);
    });
}
